import { compose } from 'redux';
import { connect } from 'react-redux';
import withBaseDrawer from 'components/common/Drawers/withBaseDrawer';
import { getBulkRightOptions } from 'redux-core/productions/selectors';
import { setBulkRightsOptions } from 'redux-core/productions/actions';

const mapStateToProps = (state) => ({
  bulkRightOptions: getBulkRightOptions(state),
});

const mapDispatchToProps = { setBulkRightsOptions };

export default compose(connect(mapStateToProps, mapDispatchToProps), withBaseDrawer);
